import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { axios } from './common';
import { HISTORY_ITEMS_PER_PAGE } from '../../pages/constants/cmConstants';

export const fetchHistoryForAlert = async ({ alertId, actionType }) => {
  const params = {
    alertId,
    actionType
  };

  const url = `${CM_BASE_URL}/history`;

  return axios.get(url, { params }).then((res) => {
    if (res.status !== 200) {
      throw { message: 'Failed to fetch alert history' };
    }
    return res.data;
  });
};

export const fetchHistoryForCase = async ({ caseId, currentHistoryPage }) => {
  const params = {
    caseId,
    offset: (currentHistoryPage - 1) * HISTORY_ITEMS_PER_PAGE,
    limit: HISTORY_ITEMS_PER_PAGE
  };

  const url = `${CM_BASE_URL}/history`;

  return axios.get(url, { params }).then((res) => {
    if (res.status !== 200) {
      throw { message: 'Failed to fetch case history' };
    }
    return res.data;
  });
};

export const fetchStrReportHistoryForCase = async ({
  reportId,
  currentHistoryPage
}) => {
  const params = {
    reportId,
    offset: (currentHistoryPage - 1) * HISTORY_ITEMS_PER_PAGE,
    limit: HISTORY_ITEMS_PER_PAGE
  };

  const url = `${CM_BASE_URL}/reports/StrOrCtr/events`;

  return axios.get(url, { params }).then((res) => {
    if (res.status !== 200) {
      throw new Error({ message: 'Failed to fetch case history' });
    }
    return res.data;
  });
};
